var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"app": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"Help":1,"moV4":1,"orders":1,"orderSearch":1,"widOrderDetails":1,"widOrderconfirm":1,"orderconfirm":1,"cashbackMode":1,"Returns":1,"CancelReturn":1,"CreateBankAccount":1,"RequestCancel":1,"GetSlots":1,"NDR":1,"addressChangeV2":1,"RescheduleSlots":1,"ScheduleDelivery":1,"ScheduleDeliveryPS2":1,"OfferTnC":1,"trackOrder":1,"updateNeft":1,"returnonholdpage":1,"Troubleshooting":1,"shareOrder":1,"returnRequestTracking":1,"myChats":1,"mediaUpload":1,"UnusedSecondFold":1,"OrderDetailsSecondFold":1,"FiltersChunk":1,"PartnerWidgetsChunk":1,"PreorderCardV3Chunk":1,"PriceLockCardV3Chunk":1,"PboOrderCardChunk":1,"BNPLOnHoldWidgetChunk":1,"WinterMOLottie":1,"TakeATourTooltipChunk":1,"BottomSheetFiltersChunk":1,"widFeedModule":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr